import { queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import type { ProdutoAdicionalStatus } from '../types/enum';
import { ProdutoAdicionalSchema } from '../types/ProdutoAdicional';

export type ProdutoAdicionalConsultarParams = DefaultApiParams &
    Partial<{
        status: ProdutoAdicionalStatus;
        pesquisar: string;
    }>;

const schema = registrosSchema(ProdutoAdicionalSchema);

export const API_PRODUTO_ADICIONAL_CONSULTAR = 'ProdutoAdicional/Consultar';

function apiProdutoAdicionalConsultar(params: ProdutoAdicionalConsultarParams) {
    return fetchApi({
        endpoint: API_PRODUTO_ADICIONAL_CONSULTAR,
        method: 'get',
        params,
        schema,
    });
}

export function apiProdutoAdicionalConsultarQueryOptions(params: ProdutoAdicionalConsultarParams) {
    return queryOptions({
        queryFn: () => apiProdutoAdicionalConsultar(params),
        queryKey: [API_PRODUTO_ADICIONAL_CONSULTAR, params],
    });
}
